"use client";
import React, { useRef, useEffect, useState } from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/Elecinstallation.css";

import Header from './Header';
import Footer from './Footer';
import Beams from "./Beams";

import image1 from "../assets/solar1A.avif";
import image2 from "../assets/solar2A.jpg";
import image3 from "../assets/solar3A.jpg";
import image4 from "../assets/solar12A.avif";
import image5 from "../assets/solar13A.jpg";
import image6 from "../assets/solar14A.webp";
import image7 from "../assets/solar8A.jpeg";
import image8 from "../assets/solar9A.jpg";
import image9 from "../assets/solar10A.jpeg";
import image10 from "../assets/solar8A.jpeg";
import image11 from "../assets/solar12A.jpg";
import image12 from "../assets/solargraph.png";

const ElecDesignHeroSection = ({ data }) => {
  const timelineRef = useRef(null);
  const containerRef = useRef(null);
  const [timelineHeight, setTimelineHeight] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const calculateAndUpdateTimelineHeight = () => {
      if (timelineRef.current) {
        const newHeight = timelineRef.current.getBoundingClientRect().height;
        setTimelineHeight(prevHeight => {
          if (newHeight > 0 && (newHeight !== prevHeight || prevHeight === 0)) {
            return newHeight;
          }
          return prevHeight;
        });
      }
    };

    const handleLayoutReady = () => {
      calculateAndUpdateTimelineHeight();
      AOS.refresh();
    };

    const initialCalcTimer = setTimeout(calculateAndUpdateTimelineHeight, 50);

    if (document.readyState === "complete") {
      const readyTimer = setTimeout(handleLayoutReady, 100);
      return () => clearTimeout(readyTimer);
    } else {
      window.addEventListener("load", handleLayoutReady);
    }

    window.addEventListener("resize", handleLayoutReady);

    return () => {
      clearTimeout(initialCalcTimer);
      window.removeEventListener("load", handleLayoutReady);
      window.removeEventListener("resize", handleLayoutReady);
    };
  }, [data]);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(
    scrollYProgress,
    [0, 1],
    [0, timelineHeight]
  );
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  return (
    <div className="elec-design-hero-container" ref={containerRef}>
      <div className="elec-design-hero-header">
        <h2 className="elec-design-hero-title">Solar Energy</h2>
        <p className="elec-design-hero-description">
         We provide end-to-end solar energy solutions, from system design and installation to performance optimization and maintenance, ensuring maximum efficiency, reliability, and sustainability for every project.
        </p>
      </div>

      <div ref={timelineRef} className="elec-design-hero-timeline">
        {data.map((item, index) => (
          <div key={index} className="elec-design-hero-step">
            <div className="elec-design-hero-sticky">
              <div className="elec-design-hero-marker-outer">
                <div className="elec-design-hero-marker-inner" />
              </div>
              <h3 className="elec-design-hero-step-title-desktop">{item.title}</h3>
            </div>

            <div className="elec-design-hero-step-content">
              <h3 className="elec-design-hero-step-title-mobile">{item.title}</h3>
              <img
                src={item.image}
                alt={item.title}
                className="elec-design-hero-step-image"
                data-aos="fade-left"
              />
              <div className="elec-design-hero-step-paragraph" data-aos="fade-left">
                {typeof item.paragraph === "string" ? (
                  <p>{item.paragraph}</p>
                ) : (
                  <>
                    <p>{item.paragraph?.text}</p>
                    {Array.isArray(item.paragraph?.points) &&
                      item.paragraph.points.map((point, idx) => (
                        <p key={idx} className="elec-design-hero-step-point">
                          <span className="elec-design-hero-arrow-icon">→</span> {point}
                        </p>
                      ))}
                  </>
                )}
              </div>
            </div>
          </div>
        ))}

        <div
          style={{ height: `${timelineHeight}px` }}
          className="elec-design-hero-progress-bar-wrapper"
        >
          <motion.div
            style={{
              height: heightTransform,
              opacity: opacityTransform,
            }}
            className="elec-design-hero-progress-bar"
          />
        </div>
      </div>
    </div>
  );
};

const Renewable = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const timelineData = [
    {
      title: "Who We Are",
      image: image7,
      paragraph: {
        points: [
          " Committed to powering industries with reliable and efficient solar energy.",
          " Your trusted partner for comprehensive industrial solar system maintenance."
        ],
      },
    },
    {
      title: "Our Core Services",
      image: image8,
      paragraph: {
        points: [
  "Industrial Solar Maintenance: Expert maintenance services to ensure your solar systems operate at peak efficiency.",
  "System Design: Customized solar energy systems designed for industrial applications.",
  "Energy Storage Solutions: Advanced battery systems to optimize energy usage and storage.",
  "Consulting Services: Professional advice and support for all your solar energy projects."
],
      },
    },
     {
      title: "Why Partner with Us?",
      image: image9,
      paragraph: {
        points: [
  "	Expertise: Highly experienced team specializing in industrial solar systems.",
  "	Quality: Utilization of top-quality solar products and cutting-edge technology.",
  "	Sustainability: Strong commitment to reducing carbon footprint and promoting renewable energy.",
  "	Customer Satisfaction: Dedicated to providing exceptional service and support.",
  "	Affordability: Competitive pricing and attractive financing options."
],
      },
    },
    {
      title: "Our Achievements",
      image: image10,
      paragraph: {
        points: [
  "	Successful maintenance of numerous industrial solar projects.",
  "	Case studies highlighting our effective and innovative solar maintenance solutions.",
  "	Testimonials from satisfied industrial clients praising our reliability and expertise.",
],
      },
    },
    {
      title: "Get in Touch",
      image: image11,
      paragraph: {
        points: [
  "	Contact Us: Reach out for a free consultation and quote on industrial solar maintenance.",
  "	Locations: Conveniently located offices to serve clients nationwide.",
  "	Support: Dedicated customer support team available to answer your questions.",
],
      },
    },
  ];

  return (
  <>
  <Header />
  <div className="elec-installation-page-container">
    <div className="elec-installation-page-header">
      <h1>Renewable Energy</h1>
      <p>
        Our Solar Energy Services deliver comprehensive solutions that harness the power of the sun to create efficient, sustainable, and cost-effective energy systems. From initial site assessment and custom system design to expert installation and ongoing maintenance, we ensure every solar project maximizes energy production and reliability. With a commitment to quality and innovation, we empower you to transition smoothly to clean, renewable energy with confidence and long-term performance.
      </p>
    </div>

    <div className="elec-installation-cube-wrapper">
      <div className="elec-installation-cube-gallery">
        <img src={image1} alt="Engineering Slide 1" />
        <img src={image2} alt="Engineering Slide 2" />
        <img src={image3} alt="Engineering Slide 3" />
        <img src={image4} alt="Engineering Slide 4" />
        <img src={image5} alt="Engineering Slide 5" />
        <img src={image6} alt="Engineering Slide 6" />
      </div>
    </div>

    <div className="elec-installation-silk-bg">
       <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
    </div>
  </div>

  <ElecDesignHeroSection data={timelineData} />

  {/* 👇 Centered Medium-Sized Image Section */}
  <div className="elec-installation-centered-image">
    <img src={image12} alt="Solar Panel System" />
  </div>

  <Footer />
</>

  );
};

export default Renewable;
